let OneStepNoTimePanel = xClass("OneStepNoTimePanel", BasePanel, () => {
    return cc.CSLoader.createNode("cocos/one_step_get_count_panel.csb")
})
let OneStepNoTimePanelEvent = {
    Close: "ONESTEPNOTIMEPANELEVENT.CLOSE",
    ShareMessage: "ONESTEPNOTIMEPANELEVENT.SHAREMESSAGE",
    WatchVideo: "ONESTEPNOTIMEPANELEVENT.WATCHVIDEO",
}
OneStepNoTimePanel.resources = [
    "font/zzgftongxin_40_greenstroke.fnt",
    "cocos/one_step_get_count_panel.csb",
    "cocos/one_step_btn_help.csb",
    "cocos/one_step_btn_video.csb",
    "cocos/one_step.plist",
    "font/zzgftongxin_40_brownstroke.fnt"
]
OneStepNoTimePanel.load = function () {
    return new Promise((resolve, reject) => {
        preloadWithLoading(OneStepNoTimePanel.resources, resolve, reject, reject)
    })
}
OneStepNoTimePanel.prototype.ctor = function () {
    let self = this
    self.cat = "onePass"
    self.subCat = "click_gethelp_btn"
    BasePanel.prototype.ctor.call(self)
    var snsProxy = require("clover/sns/SnsProxy").getInstance()
    self.initUI(self.canShowVideoButton() && snsProxy.videoAd)
}
OneStepNoTimePanel.prototype.getVideoKey = function () {
    return "oneStep_" + OneStepActivityManager.getInstance().begin
}
OneStepNoTimePanel.prototype.getConfigNoShareDays = function () {
    return OneStepActivityManager.getInstance().noShareDays
}
OneStepNoTimePanel.prototype.getConfigTodayVideoCount = function () {
    return OneStepActivityManager.getInstance().todayVideoCount
}
OneStepNoTimePanel.prototype.canShowVideoButton = function () {
    let self = this
    let getCountNoShare = Persistence.readFileData(LocalDataFiles.kGetCountNoShare) || {}
    let change = false
    let noShareInfo
    let key = self.getVideoKey()
    if (getCountNoShare[key]) {
        noShareInfo = getCountNoShare[key]
    } else {
        noShareInfo = {}
        getCountNoShare[key] = noShareInfo
        change = true
    }

    let nowDay = Localhost.timeInDay()

    if (noShareInfo.timeInDay == undefined) {
        noShareInfo.timeInDay = nowDay
        noShareInfo.noShareDays = 0
        noShareInfo.todayVideoCount = 0
        change = true
    }
    if (noShareInfo.timeInDay != nowDay) {
        // 新的一天，把noShareDays增加1
        noShareInfo.noShareDays = (noShareInfo.noShareDays || 0) + 1
        noShareInfo.timeInDay = nowDay
        noShareInfo.todayVideoCount = 0
        change = true
    }

    if (change) {
        Persistence.writeFileData(getCountNoShare, LocalDataFiles.kGetCountNoShare)
    }

    let todayVideoCount = noShareInfo.todayVideoCount || 0

    if (noShareInfo.noShareDays >= self.getConfigNoShareDays() && todayVideoCount < self.getConfigTodayVideoCount()) {
        return true
    }

    return false
}
OneStepNoTimePanel.prototype.initUI = function (showVideo) {
    let self = this

    self.videoBtn = self.getChildByName("btn_video")
    self.helpBtn = self.getChildByName("btn_help")

    if (showVideo) {
        quickBuildUIGLabelButton(self.videoBtn, () => {
            self.onVideoBtnClick()
            DCAssist.dc4ShareSend(self.cat, "ad_btn_click")
        })
        self.videoBtn.setString("看视频")
    } else {
        self.videoBtn.removeFromParent()
        self.helpBtn.x = self.width / 2
    }

    quickBuildUIGLabelButton(self.helpBtn, () => {
        // var dcCb = function(textId){
        //     DCAssist.dc4ClickShare(self.cat, self.subCat+"_success", {"textid":textId});
        // }
        self.dispatchEvent({
            name: OneStepNoTimePanelEvent.ShareMessage,
     //       dcCb: dcCb
        })
       // DCAssist.userTrack(self.cat, self.subCat);
        
        // 把noShareDays清零
        let getCountNoShare = Persistence.readFileData(LocalDataFiles.kGetCountNoShare) || {}
        let key = self.getVideoKey()
        if (getCountNoShare[key] && getCountNoShare[key].noShareDays >= 0) {
            getCountNoShare[key].noShareDays = -1 // 第二天更新时会变为0
        }
        Persistence.writeFileData(getCountNoShare, LocalDataFiles.kGetCountNoShare)
    })
    self.helpBtn.setString("求助好友")

    self.closeBtn = self.getChildByName("btn_close")
    quickBuildUIBUtton(self.closeBtn, () => {
        self.onClose(() => {
            self.dispatchEvent({
                name: OneStepNoTimePanelEvent.Close
            })
        })
    })
}

OneStepNoTimePanel.prototype.sendWatchVideoHttp = function () {
    let self = this
    return new Promise((resolve, reject) => {
        let http = OneStepWatchVideoHttp.new()
        http.addEventListener(Events.kComplete, (evt) => {
            resolve()
        })
        http.addEventListener(Events.kError, () => {
            reject()
        })
        http.addEventListener(Events.kCancel, () => {
            reject()
        })
        http.load()
    })
}

OneStepNoTimePanel.prototype.onVideoHttpResponse = function () {
    let self = this
    let manager = OneStepActivityManager.getInstance()
    manager.leftTimes++
    
    let getCountNoShare = Persistence.readFileData(LocalDataFiles.kGetCountNoShare) || {}
    let noShareInfo
    let key = self.getVideoKey()
    if (getCountNoShare[key]) {
        noShareInfo = getCountNoShare[key]
    } else {
        noShareInfo = {}
        getCountNoShare[key] = noShareInfo
    }
    noShareInfo.todayVideoCount = (noShareInfo.todayVideoCount || 0) + 1
    Persistence.writeFileData(getCountNoShare, LocalDataFiles.kGetCountNoShare)

    self.onClose(() => {
        self.dispatchEvent({
            name: OneStepNoTimePanelEvent.Close
        })
    })
}

OneStepNoTimePanel.prototype.onVideoBtnClick = function () {
    let self = this

    var snsProxy = require("clover/sns/SnsProxy").getInstance()

    if (!snsProxy.videoAd) {
        let hintMsg = "您的微信版本过低，请升级后重试";
        if (META.platform == XcloverPlatform.qq){
            hintMsg = getText("video.tip.wb.unsupport")//"空间版本不支持小视频,请从qq进入小游戏";
        }
        Toast.make(hintMsg);
        cc.log("unsupported wx version for ad");
        self.isBusy = false
        return
    }

    snsProxy.onRewardedVideoAdClose(function () {
        DCAssist.userTrack(self.cat, "ad_finish")

        self.sendWatchVideoHttp().then(function () {
            self.onVideoHttpResponse()
        }).catch(function () {
            Toast.make("增加次数失败")
        })

    }, function dropoutAdWatch() {
        self.isBusy = false
        DCAssist.userTrack(self.cat, "ad_dropout")
        Toast.make(getText("error.tip.dropout_ad"))
    })

    snsProxy.onRewardedVideoAdError((err) => {
        snsProxy.offRewardedVideoAdError()
        self.isBusy = false
        DCAssist.userTrack(self.cat, "noAds")
        if (window.logCenter) {
            let msg = {
                message: self.cat + " onRewardedVideoAdError: " + JSON.stringify(err)
            }
            window.logCenter.log(msg)
        } else {
            cc.error(self.cat + "onRewardedVideoAdError: " + err.errMsg)
        }
    })

    snsProxy.playRewardedVideoAd()


}
OneStepNoTimePanel.prototype.onCleanup = function () {
    ResManager.release(OneStepNoTimePanel.resources)
}
module.exports = [OneStepNoTimePanel, OneStepNoTimePanelEvent]